// extracted by mini-css-extract-plugin
export default {"image":"tY-z","loaded":"uY-z"};